import { getAuthToken } from '../../firebase/auth';
import { CLOUD_FUNCTIONS_URL } from '../config/environment.config';

class TwilioService {
  constructor() {
    this.baseUrl = CLOUD_FUNCTIONS_URL;

    if (!this.baseUrl) {
      console.warn('Cloud Functions URL non configurée');
    }
  }

  async getHeaders() {
    const token = await getAuthToken();
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
  }

  async sendVerificationCode(phoneNumber, channel = 'sms') {
    try {
      if (!this.baseUrl) {
        throw new Error('URL de l\'API non configurée');
      }
      
      const headers = await this.getHeaders();
      const response = await fetch(`${this.baseUrl}/verify/start`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ phoneNumber, channel })
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Failed to send verification code');
      }
      
      return data;
    } catch (error) {
      console.error('Error sending verification code:', error);
      throw error;
    }
  }

  async verifyCode(phoneNumber, code, channel = 'sms') {
    try {
      if (!this.baseUrl) {
        throw new Error('URL de l\'API non configurée');
      }
      
      const headers = await this.getHeaders();
      const response = await fetch(`${this.baseUrl}/verify/check`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ phoneNumber, code, channel })
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Failed to verify code');
      }
      
      return data;
    } catch (error) {
      console.error('Error verifying code:', error);
      throw error;
    }
  }
}

export const twilioService = new TwilioService();
